import { GoDownload } from 'react-icons/go';

import IconButton from 'components/ui/IconButton';
import Menu from 'components/Menu';
import DownloadMenu from './DownloadMenu/DownloadMenu';

const DownloadButton = () => {
  return (
    <Menu
      trigger={
        <IconButton $size={44} $hasRadius $hasBgColor>
          <GoDownload />
        </IconButton>
      }
      minWidth={350}
    >
      <DownloadMenu />
    </Menu>
  );
};

export default DownloadButton;
